












import BaseComponent from '@/components/base-component.vue';
import { getUFs } from '@/services/utils';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class UiAutocompleteUF extends BaseComponent {
  @Prop()
  value: any;

  selected: any = null;

  loading = false;
  ufs = [];

  @Watch('value', { immediate: true })
  onValueChange(v) {
    this.selected = v;
  }

  mounted() {
    getUFs().subscribe((res) => {
      this.ufs = res;
    });
  }

  onChange() {
    this.$emit('input', this.selected);
    this.$emit('change', this.selected);
  }
}
